// extracted by mini-css-extract-plugin
export default {"base":"FktbH","action-1":"XuXD3","action-2":"rekkg","action-3":"M6snI"};